<ng-container *ngIf="action$ | async"></ng-container>
<ng-container *ngIf="data$ | async"></ng-container>

<table class="w-full" mat-table #table [dataSource]="dataSource">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef i18n>Название</th>
    <td mat-cell *matCellDef="let row">{{ row.name }}</td>
  </ng-container>

  <ng-container matColumnDef="base">
    <th mat-header-cell *matHeaderCellDef i18n>База</th>
    <td mat-cell *matCellDef="let row">
      <csl-base-point-thumbnail [active]="getBasePointAnglePosition(row.position, row.basePoint)">
      </csl-base-point-thumbnail>
    </td>
  </ng-container>

  <ng-container matColumnDef="coord">
    <th mat-header-cell *matHeaderCellDef i18n>Координаты</th>
    <td mat-cell *matCellDef="let row">{{ row.x }} ; {{ row.y }}</td>
  </ng-container>

  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef>
      <button
        data-testid="addFastener"
        [disabled]="disabled"
        mat-icon-button
        (click)="addFastener()"
        i18n-matTooltip
        matTooltip="Добавить">
        <mat-icon>add_circle_outline</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let row">
      <button data-testid="deleteFastener" [disabled]="disabled" mat-icon-button (click)="delete(row)">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>
